import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
// @ts-ignore
import { HelmetProvider } from 'react-helmet-async';
import { Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import Privacy from "./pages/Privacy";
import NotFound from "./pages/NotFound";
import { ThemeProvider } from "./components/ThemeProvider";
import { CookieConsentBanner } from "./components/CookieConsentBanner";

// Import i18n configuration
import "./i18n/i18n";

// Create a client
const queryClient = new QueryClient();

const AppRoutes = () => (
  <Routes>
    {/* Use simple path strings without colons or special patterns */}
    <Route path="/" element={<Index />} />
    <Route path="/blog" element={<Blog />} />
    {/* If you need path parameters, define them correctly */}
    <Route path="/blog/:id" element={<BlogArticle />} />
    <Route path="/privacy" element={<Privacy />} />
    {/* Add a catch-all route at the end */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const App = () => {
  // On the server, we don't need the BrowserRouter
  // We use StaticRouter in entry-server.tsx instead
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <ThemeProvider>
            <Toaster />
            <Sonner />
            <AppRoutes />
            <CookieConsentBanner position="bottom-right" compact={true} />
          </ThemeProvider>
        </TooltipProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
